import { User_role } from "@prisma/client";
import CulbGlobalMenuIcon from "public/icons/menu/CulbGlobalMenuIcon.svg";
import MypageGlobalMenuIcon from "public/icons/menu/MypageGlobalMenuIcon.svg";
import SessionGlobalMenuIcon from "public/icons/menu/SessionGlobalMenuIcon.svg";
import ShopGlobalMenuIcon from "public/icons/menu/ShopGlobalMenuIcon.svg";
import ShopMenuIcon from "public/icons/menu/ShopMenuIcon.svg";
import StyleMenuIcon from "public/icons/menu/StyleMenuIcon.svg";
import {
  MdClear,
  MdFavoriteBorder,
  MdLightbulbOutline,
  MdLogout,
  MdOutlinedFlag,
  MdOutlineFactCheck,
  MdOutlineGroup,
  MdOutlineMilitaryTech,
  MdOutlineNote,
  MdOutlineSettings,
  MdWorkOutline,
} from "react-icons/md";

/* eslint-disable */

// PC表示サイドバーメニュー
export const SIDEBAR_PATH = [
  {
    label: "マイページ",
    href: "/mypage",
    icon: (
      <MypageGlobalMenuIcon
        size={30}
        stroke="#2D3336"
        style={{ margin: "2px" }}
      />
    ),
  },
  {
    label: "セッション",
    href: "/session",
    icon: (
      <SessionGlobalMenuIcon
        size={24}
        stroke="#2D3336"
        style={{ margin: "2px" }}
      />
    ),
  },
  {
    label: "フムフム",
    href: "/fumufumu/public",
    icon: <MdLightbulbOutline size={24} color="#2D3336" />,
  },
  {
    label: "マイキャリアパス",
    href: "/my-career-path",
    icon: <MdWorkOutline size={24} color="#2D3336" />,
    roles: [User_role.FREE_USER, User_role.STUDENT],
  },
  {
    label: "クローゼット",
    href: "/closet",
    icon: <ShopGlobalMenuIcon stroke="#2D3336" style={{ margin: "2px" }} />,
  },
  {
    label: "ショップ",
    href: "/shop",
    icon: <ShopMenuIcon size={24} color="#2D3336" />,
  },
  {
    label: "スタイル",
    href: "/style",
    icon: <StyleMenuIcon size={24} color="#2D3336" />,
  },
  {
    label: "部室",
    href: "/clubroom",
    icon: <CulbGlobalMenuIcon stroke="#2D3336" style={{ margin: "2px" }} />,
  },
  {
    label: "メンバー 一覧",
    href: "/member/recommended",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "コーチ一覧",
    href: "/coach-list",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "推しのコ",
    href: "/my-favorites",
    icon: <MdFavoriteBorder size={24} color="#2D3336" />,
    roles: [User_role.COACH, User_role.FREE_USER, User_role.STUDENT],
  },
  {
    label: "ランキング",
    href: "/ranking/monthlyFumufumuRanking",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "ステータス",
    href: "/status",
    icon: <MdOutlineFactCheck size={24} color="#2D3336" />,
  },
  {
    label: "ミッション",
    href: "/mission",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "バッジ",
    href: "/badge",
    icon: <MdOutlineMilitaryTech size={24} color="#2D3336" />,
  },

  {
    label: "設定",
    href: "/setting",
    icon: <MdOutlineSettings size={24} color="#2D3336" />,
  },
  {
    label: "ガイドライン",
    href: process.env.NEXT_PUBLIC_GUIDELINE_URL as string,
    icon: <MdOutlineNote size={24} color="#2D3336" />,
  },
  {
    label: "ログアウト",
    href: "/",
    icon: <MdLogout size={24} color="#2D3336" />,
  },
] as const;

// 無料ユーザー用PC表示サイドバーメニュー
export const FREE_USER_SIDEBAR_PATH = [
  {
    label: "マイページ",
    href: "/mypage",
    icon: (
      <MypageGlobalMenuIcon
        size={30}
        stroke="#2D3336"
        style={{ margin: "2px" }}
      />
    ),
  },
  {
    label: "フムフム",
    href: "/fumufumu/public",
    icon: <MdLightbulbOutline size={24} color="#2D3336" />,
  },
  {
    label: "マイキャリアパス",
    href: "/my-career-path",
    icon: <MdWorkOutline size={24} color="#2D3336" />,
  },
  {
    label: "クローゼット",
    href: "/closet",
    icon: <ShopGlobalMenuIcon stroke="#2D3336" style={{ margin: "2px" }} />,
  },
  {
    label: "ショップ",
    href: "/shop",
    icon: <ShopMenuIcon size={24} color="#2D3336" />,
  },
  {
    label: "スタイル",
    href: "/style",
    icon: <StyleMenuIcon size={24} color="#2D3336" />,
  },
  {
    label: "部室",
    href: "/clubroom",
    icon: <CulbGlobalMenuIcon stroke="#2D3336" style={{ margin: "2px" }} />,
  },
  {
    label: "メンバー 一覧",
    href: "/member/recommended",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "コーチ一覧",
    href: "/coach-list",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "推しのコ",
    href: "/my-favorites",
    icon: <MdFavoriteBorder size={24} color="#2D3336" />,
    roles: [User_role.COACH, User_role.FREE_USER, User_role.STUDENT],
  },
  {
    label: "ランキング",
    href: "/ranking/monthlyFumufumuRanking",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "ミッション",
    href: "/mission",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "バッジ",
    href: "/badge",
    icon: <MdOutlineMilitaryTech size={24} color="#2D3336" />,
  },
  {
    label: "設定",
    href: "/setting",
    icon: <MdOutlineSettings size={24} color="#2D3336" />,
  },
  {
    label: "ガイドライン",
    href: process.env.NEXT_PUBLIC_GUIDELINE_URL as string,
    icon: <MdOutlineNote size={24} color="#2D3336" />,
  },
  {
    label: "ログアウト",
    href: "/",
    icon: <MdLogout size={24} color="#2D3336" />,
  },
] as const;

// SP表示フッターメニュー
export const FOOTER_MENU_PATH = [
  { label: "マイページ", href: "/mypage", icon: MypageGlobalMenuIcon },
  { label: "セッション", href: "/session", icon: SessionGlobalMenuIcon },
  { label: "フムフム", href: "/fumufumu/public", icon: MdLightbulbOutline },
  { label: "クローゼット", href: "/closet", icon: ShopGlobalMenuIcon },
  {
    label: "部室",
    href: "/clubroom",
    icon: CulbGlobalMenuIcon,
  },
] as const;
// 無料ユーザー用SP表示フッターメニュー
export const FREE_USER_FOOTER_MENU_PATH = [
  { label: "マイページ", href: "/mypage", icon: MypageGlobalMenuIcon },
  { label: "フムフム", href: "/fumufumu/public", icon: MdLightbulbOutline },
  { label: "クローゼット", href: "/closet", icon: ShopGlobalMenuIcon },
  {
    label: "部室",
    href: "/clubroom",
    icon: CulbGlobalMenuIcon,
  },
] as const;

// SP表示ドロワーメニュー
export const DRAWER_MENU_PATH = [
  {
    label: "メンバー 一覧",
    href: "/member/recommended",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "コーチ一覧",
    href: "/coach-list",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "推しのコ",
    href: "/my-favorites",
    icon: <MdFavoriteBorder size={24} color="#2D3336" />,
    roles: [User_role.COACH, User_role.FREE_USER, User_role.STUDENT],
  },
  {
    label: "マイキャリアパス",
    href: "/my-career-path",
    icon: <MdWorkOutline size={24} color="#2D3336" />,
    roles: [User_role.FREE_USER, User_role.STUDENT],
  },
  {
    label: "ランキング",
    href: "/ranking/monthlyFumufumuRanking",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "ステータス",
    href: "/status",
    icon: <MdOutlineFactCheck size={24} color="#2D3336" />,
  },
  {
    label: "ミッション",
    href: "/mission",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "バッジ",
    href: "/badge",
    icon: <MdOutlineMilitaryTech size={24} color="#2D3336" />,
  },
  { label: "ショップ", href: "/shop", icon: <ShopMenuIcon /> },
  { label: "スタイル", href: "/style", icon: <StyleMenuIcon /> },
  {
    label: "設定",
    href: "/setting",
    icon: <MdOutlineSettings size={24} color="#2D3336" />,
  },
  {
    label: "ガイドライン",
    href: process.env.NEXT_PUBLIC_GUIDELINE_URL as string,
    icon: <MdOutlineNote size={24} color="#2D3336" />,
  },
  {
    label: "ログアウト",
    href: "/",
    icon: <MdLogout size={24} color="#2D3336" />,
  },
] as const;

// 無料ユーザー用SP表示ドロワーメニュー
export const FREE_USER_DRAWER_MENU_PATH = [
  {
    label: "メンバー 一覧",
    href: "/member/recommended",
    icon: <MdOutlineGroup size={24} color="#2D3336" />,
  },
  {
    label: "推しのコ",
    href: "/my-favorites",
    icon: <MdFavoriteBorder size={24} color="#2D3336" />,
  },
  {
    label: "マイキャリアパス",
    href: "/my-career-path",
    icon: <MdWorkOutline size={24} color="#2D3336" />,
  },
  {
    label: "ランキング",
    href: "/ranking/monthlyFumufumuRanking",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "ミッション",
    href: "/mission",
    icon: <MdOutlinedFlag size={24} color="#2D3336" />,
  },
  {
    label: "バッジ",
    href: "/badge",
    icon: <MdOutlineMilitaryTech size={24} color="#2D3336" />,
  },
  { label: "ショップ", href: "/shop", icon: <ShopMenuIcon /> },
  { label: "スタイル", href: "/style", icon: <StyleMenuIcon /> },
  {
    label: "設定",
    href: "/setting",
    icon: <MdOutlineSettings size={24} color="#2D3336" />,
  },
  {
    label: "ガイドライン",
    href: process.env.NEXT_PUBLIC_GUIDELINE_URL as string,
    icon: <MdOutlineNote size={24} color="#2D3336" />,
  },
  {
    label: "ログアウト",
    href: "/",
    icon: <MdLogout size={24} color="#2D3336" />,
  },
] as const;

// コーチ権限でのメニュー
export const COACH_AUTHORITY_PATH = {
  label: "コーチ用セッション",
  href: "/coach",
  icon: <MdClear size={24} color="#2D3336" />,
};

// 管理者権限でのメニュー
export const ADMIN_AUTHORITY_PATH = {
  label: "運営画面",
  href: "/admin/session",
  icon: <MdClear size={24} color="#2D3336" />,
};

// コーチ用管理画面
export const COACH_ADMIN_SIDEBAR_PATH = [
  { label: "マイページ", href: "/mypage" },
  { label: "コーチ用セッション", href: "/coach" },
  // Hide the user list for coaches
  // { label: "ユーザー一覧", href: "/userlist" },
];

// 運営用管理画面
export const ADMIN_SIDEBAR_PATH = [
  { label: "マイページ", href: "/mypage" },
  { label: "コーチ用セッション", href: "/coach" },
  { label: "ユーザー一覧", href: "/admin/userlist" },
  { label: "セッション", href: "/admin/session" },
  { label: "実施セッション", href: "/admin/implementsession" },
  { label: "コーチ一覧", href: "/admin/coachlist" },
  { label: "未承認ユーザー一覧", href: "/admin/unapproveduserlist" },
  { label: "未承認コーチ一覧", href: "/admin/unapprovedcoach" },
  { label: "カテゴリー", href: "/admin/category" },
  { label: "クラス", href: "/admin/period" },
  { label: "コース", href: "/admin/course" },
  { label: "組織一覧", href: "/admin/organizations" },
  { label: "開催場所", href: "/admin/venue" },
  { label: "ワークシート一覧", href: "/admin/worksheet" },
  { label: "はたらくマインド一覧", href: "/admin/mind" },
  { label: "お申し込み一覧", href: "/admin/entry" },
  { label: "招待コード一覧", href: "/admin/invitation-codes" },
  { label: "体験会希望日時一覧", href: "/admin/entry-datetimes" },
  { label: "通知管理一覧", href: "/admin/notification-triggers" },
  { label: "抑制メールアドレス一覧", href: "/admin/suppression-emails" },
  { label: "スケジュール", href: "/admin/schedules" },
  { label: "CSVエクスポート", href: "/admin/csv-export" },
] as const;
